import React from "react";
import {
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    Divider,
    Avatar,
    IconButton,
    Button,
    styled
} from "@mui/material";
import { Instagram, Twitter } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import SyncIcon from "@mui/icons-material/Sync";

const FooterSec = styled(Box)(({ theme }) => ({
    padding: "0 1.25rem",
    backgroundColor: "#1976D2",
    display: "flex",
    color: "#fff",
    justifyContent: "space-between"
}));

const ProposalDocument: React.FC = () => {
    const proposalData = {
        proposalNumber: "0000",
        date: "01.06.2022",
        from: {
            company: "MachineMaze",
            address: "789 Elm Street",
            zipCode: "78910 Springfield",
            email: "contact@domain.com"
        },
        to: {
            company: "Honeywell Safety and",
            address: "Productivity Solutions",
            street: "789 Elm Street",
            email: "contact@domain.com"
        },
        project: {
            name: "PCB Fabrication for IoT Devices - Proposal",
            rfqDate: "29th August 2024"
        },
        items: [
            {
                part: "Part 01",
                description: "Description...",
                unit: "CM",
                unitPrice: 6000,
                sellingPrice: 1800,
                gst: 18,
                qty: 1,
                amount: 7000
            },
            {
                part: "Part 02",
                description: "Description...",
                unit: "CM",
                unitPrice: 18000,
                sellingPrice: 1800,
                gst: 12,
                qty: 3,
                amount: 10800
            },
            {
                part: "Part 03",
                description: "Description...",
                unit: "CM",
                unitPrice: 6000,
                sellingPrice: 1800,
                gst: 10,
                qty: 1.5,
                amount: 10800
            },
            {
                part: "Tool",
                description: "Description...",
                unit: "CM",
                unitPrice: 6000,
                sellingPrice: 1800,
                gst: 10,
                qty: 1.5,
                amount: 10800
            }
        ],
        total: 37000,
        contact: {
            name: "Full Name",
            phone: "+91123456789",
            email: "yourname@gmail.com"
        }
    };

    return (
        <>
            <Grid container>
                <Grid size={{ xs: 12, md: 9 }}>
                    <Paper
                        sx={{
                            margin: "15px",
                            padding: 3,
                            fontFamily: "Arial, sans-serif",
                            display: "flex",
                            justifyContent: "space-between"
                        }}
                    >
                        <Typography variant="h6">
                            {" "}
                            CURFQ001 Honeywell Proposal{" "}
                        </Typography>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <SyncIcon />
                            <Typography variant="caption">
                                Last updated on
                            </Typography>
                            <Button
                                variant="contained"
                                sx={{ marginLeft: "10px" }}
                            >
                                Submit
                            </Button>
                        </div>
                    </Paper>
                    <Paper
                        sx={{
                            maxWidth: 800,
                            fontFamily: "Arial, sans-serif",
                            margin: "15px auto"
                        }}
                    >
                        <div style={{ padding: "1.25rem" }}>
                            {/* Header */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    mb: 3
                                }}
                            >
                                <Avatar
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        bgcolor: "#1976d2",
                                        mr: 2,
                                        fontSize: "24px",
                                        fontWeight: "bold"
                                    }}
                                >
                                    M
                                </Avatar>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            fontWeight: "bold",
                                            color: "#1976d2"
                                        }}
                                    >
                                        Proposal | Client name
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        No. {proposalData.proposalNumber} | Date{" "}
                                        {proposalData.date}
                                    </Typography>
                                </Box>
                            </Box>

                            <Divider sx={{ mb: 3, borderStyle: "dashed" }} />

                            {/* From and To Section */}
                            <Box sx={{ display: "flex", gap: 3, mb: 3 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="h6"
                                        sx={{ fontWeight: "bold", mb: 1 }}
                                    >
                                        From
                                    </Typography>
                                    <Typography variant="body2">
                                        {proposalData.from.company}
                                    </Typography>
                                    <Typography variant="body2">
                                        {proposalData.from.address}
                                    </Typography>
                                    <Typography variant="body2">
                                        {proposalData.from.zipCode}
                                    </Typography>
                                    <Typography variant="body2">
                                        {proposalData.from.email}
                                    </Typography>
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="h6"
                                        sx={{ fontWeight: "bold", mb: 1 }}
                                    >
                                        To
                                    </Typography>
                                    <Typography variant="body2">
                                        {proposalData.to.company}
                                    </Typography>
                                    <Typography variant="body2">
                                        {proposalData.to.address}
                                    </Typography>
                                    <Typography variant="body2">
                                        {proposalData.to.street}
                                    </Typography>
                                    <Typography variant="body2">
                                        {proposalData.to.email}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Project Details */}
                            <Box sx={{ mb: 3 }}>
                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "bold", mb: 2 }}
                                >
                                    Project Details
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    <strong>Project Name:</strong>{" "}
                                    {proposalData.project.name}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>RFQ Received Date:</strong>{" "}
                                    {proposalData.project.rfqDate}
                                </Typography>
                            </Box>

                            {/* Items Table */}
                            <TableContainer
                                component={Paper}
                                variant="outlined"
                                sx={{ mb: 3 }}
                            >
                                <Table>
                                    <TableHead>
                                        <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Parts
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Unit
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Vendor Price
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Selling Price
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                GST
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                QTY
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Amount
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {proposalData.items.map(
                                            (item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontWeight:
                                                                    "bold"
                                                            }}
                                                        >
                                                            {item.part}
                                                        </Typography>
                                                        <Typography
                                                            variant="caption"
                                                            color="text.secondary"
                                                        >
                                                            {item.description}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        {item.unit}
                                                    </TableCell>
                                                    <TableCell>
                                                        ₹{" "}
                                                        {item.unitPrice.toLocaleString()}
                                                    </TableCell>
                                                    <TableCell>
                                                        ₹ {item.sellingPrice}
                                                    </TableCell>
                                                    <TableCell>
                                                        {item.gst}%
                                                    </TableCell>
                                                    <TableCell>
                                                        {item.qty}
                                                    </TableCell>
                                                    <TableCell>
                                                        ₹{" "}
                                                        {item.amount.toLocaleString()}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        )}
                                        <TableRow>
                                            <TableCell
                                                colSpan={6}
                                                sx={{
                                                    textAlign: "right",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                Total
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    fontWeight: "bold",
                                                    fontSize: "16px"
                                                }}
                                            >
                                                ₹{" "}
                                                {proposalData.total.toLocaleString()}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <img />
                        {/* Footer */}
                        <FooterSec>
                            <Box sx={{ mt: 4 }}>
                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "bold", mb: 1 }}
                                >
                                    Thank You!
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 2 }}>
                                    {proposalData.contact.name} |{" "}
                                    {proposalData.contact.phone} |{" "}
                                    {proposalData.contact.email}
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: 1
                                }}
                            >
                                <IconButton
                                    size="small"
                                    sx={{ color: "#E4405F" }}
                                >
                                    <Instagram />
                                </IconButton>
                                <IconButton
                                    size="small"
                                    sx={{ color: "#1DA1F2" }}
                                >
                                    <Twitter />
                                </IconButton>
                            </Box>
                        </FooterSec>
                    </Paper>
                </Grid>

                <Grid size={{ xs: 12, md: 3 }}>
                    <Paper
                        sx={{
                            margin: "15px auto",
                            padding: 3,
                            fontFamily: "Arial, sans-serif"
                        }}
                    >
                        fkjdlfkjjkl
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
};

export default ProposalDocument;
